import { render } from "./FAQModal.vue?vue&type=template&id=601875ff&scoped=true&ts=true"
import script from "./FAQModal.vue?vue&type=script&lang=ts"
export * from "./FAQModal.vue?vue&type=script&lang=ts"

import "./FAQModal.vue?vue&type=style&index=0&id=601875ff&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601875ff"]])

export default __exports__